var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2958 22.0289L36.3099 19.7636L40.1282 16.1306C40.6126 15.6747 40.7123 14.9624 40.3847 14.3925L36.1818 6.95561C35.8541 6.38573 35.1988 6.11504 34.5577 6.286L29.4858 7.69645L27.3487 6.44272L26.0665 1.32807C25.9098 0.701202 25.3399 0.2453 24.6845 0.2453H16.1364C15.481 0.2453 14.9111 0.701202 14.7544 1.32807L13.4722 6.44272L11.3352 7.69645L6.26325 6.286C5.62214 6.11504 4.96678 6.38573 4.6391 6.95561L0.436257 14.3925C0.108577 14.9624 0.208306 15.6747 0.692701 16.1306L4.51088 19.7636L4.52513 22.0289L0.749689 25.7046C0.27954 26.1605 0.179812 26.8728 0.507491 27.4427L4.82431 34.8226C5.15199 35.3925 5.8216 35.6632 6.44846 35.478L11.5061 34.0105L13.4722 35.136L14.7544 40.2507C14.9111 40.8775 15.4809 41.3335 16.1364 41.3335H24.6845C25.3399 41.3335 25.9098 40.8775 26.0665 40.2507L27.3487 35.136L29.3148 34.0105L34.3724 35.478C34.9993 35.6632 35.6689 35.3925 35.9966 34.8226L40.3134 27.4427C40.6411 26.8728 40.5414 26.1605 40.0712 25.7046L36.2958 22.0289ZM20.4105 28.8674C15.9654 28.8674 12.3324 25.2344 12.3324 20.7894C12.3324 16.3443 15.9654 12.7114 20.4105 12.7114C24.8555 12.7114 28.4885 16.3443 28.4885 20.7894C28.4885 25.2344 24.8555 28.8674 20.4105 28.8674Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfig);
export default __webpack_public_path__ + "static/media/config.8dca07beee73767f9d1cf03b7ed5d6da.svg";
export { ForwardRef as ReactComponent };